export default "__VITE_ASSET__nCGeolCr__"